import { apiClient } from '@/lib/api-client';
import type {
  CampaignOfferRef,
  GuaranteeCampaignDetail,
  GuaranteeCampaignListItem,
  GuaranteeRule,
  Paginated,
} from '../../domain/entities/guarantee.entity';

const BASE = '/admin/aristo-medq/guarantee-campaigns';

export class GuaranteeApiDatasource {
  async listCampaigns(input: {
    page: number;
    perPage: number;
  }): Promise<Paginated<GuaranteeCampaignListItem>> {
    const { data } = await apiClient.get<Paginated<GuaranteeCampaignListItem>>(
      BASE,
      { params: input },
    );
    return data;
  }

  async getCampaign(id: string): Promise<GuaranteeCampaignDetail> {
    const { data } = await apiClient.get<GuaranteeCampaignDetail>(
      `${BASE}/${id}`,
    );
    return data;
  }

  async createCampaign(input: {
    name: string;
    rule: GuaranteeRule;
  }): Promise<GuaranteeCampaignDetail> {
    const { data } = await apiClient.post<GuaranteeCampaignDetail>(BASE, input);
    return data;
  }

  async renameCampaign(id: string, name: string): Promise<void> {
    await apiClient.patch(`${BASE}/${id}`, { name });
  }

  async addOffer(id: string, offer: CampaignOfferRef): Promise<void> {
    await apiClient.post(`${BASE}/${id}/offers`, offer);
  }

  async removeOffer(id: string, offer: CampaignOfferRef): Promise<void> {
    await apiClient.delete(`${BASE}/${id}/offers`, { data: offer });
  }

  async updateRule(id: string, rule: GuaranteeRule): Promise<void> {
    await apiClient.put(`${BASE}/${id}/rule`, rule);
  }
}
